import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

interface TypewriterTextProps {
  text: string;
  className?: string;
}

export default function TypewriterText({ text, className = '' }: TypewriterTextProps) {
  const [displayedText, setDisplayedText] = useState('');
  const [cursorPosition, setCursorPosition] = useState(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  
  useEffect(() => {
    let currentIndex = 0;
    const typingSpeed = 150;
    const targetIndex = text.length;

    const typeText = () => {
      if (currentIndex <= targetIndex) {
        setDisplayedText(text.slice(0, currentIndex));
        setCursorPosition(currentIndex);
        currentIndex++;
        setTimeout(typeText, typingSpeed);
      } else {
        setIsTypingComplete(true);
      }
    };

    typeText();
    
    return () => {
      currentIndex = targetIndex + 1;
    };
  }, [text]);

  return (
    <div className="relative inline-block">
      <span className={`font-mono ${className}`}>
        {displayedText}
      </span>
      <motion.div
        initial={{ opacity: 1 }}
        animate={{
          opacity: [1, 0],
          transition: {
            duration: 0.8,
            repeat: Infinity,
            repeatType: "reverse"
          }
        }}
        className="absolute top-0 h-full w-[2px] bg-blue-400"
        style={{
          left: `calc(${cursorPosition}ch + 2px)`, // Added 2px offset
          boxShadow: '0 0 8px #60A5FA'
        }}
      />
    </div>
  );
}